module.exports = __webpack_public_path__ + "img/kolahduzan-sign.bf889e2d.jpeg";